import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import ContentStream from "./components/ContentStream";
import HeadlineFeature from "./components/HeadlineFeature";
import TruthTimeline from "./components/TruthTimeline";
import ClueBoard from "./components/ClueBoard";
import Analysis from "./components/Analysis";
import RelationMap from "./components/RelationMap";
import About from "./components/About";
import Faq from "./components/Faq";
import CtaForms from "./components/CtaForms";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <HotList />
        <ContentStream />
        <HeadlineFeature />
        <TruthTimeline />
        <ClueBoard />
        <Analysis />
        <RelationMap />
        <About />
        <Faq />
        <CtaForms />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}